module.exports = __webpack_public_path__ + "img/checkps.34b17199.jpeg";